import { useQuery } from "@tanstack/react-query";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import RevenueByLocations from "../../RevenueByLocations";
import { useMemo } from "react";

const DashboardHeatmap = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: dataIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-heatmap-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchHeatmap(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  const topCountries = useMemo(() => {
    const result = [];
    if (dashboardData?.topCountries) {
      for (const [key, value] of Object.entries(dashboardData.topCountries)) {
        if (Number(value) !== 0) {
          result[key] = value;
        }
      }
    }
    return result;
  }, [dashboardData?.topCountries]);

  return (
    <RevenueByLocations
      countries={dashboardData?.allCountries || {}}
      topCountries={topCountries}
      isLoading={dataIsFetching}
    />
  );
};

export default withNamespaces()(DashboardHeatmap);
